import { useState } from 'react'
import { useAuth } from '../../App'
import { collectionDatalistItems } from '../../lib/collectionDatalist'
import { CollectionSearchInput } from '../ui/CollectionDatalist'
import { collectionDatalistLabel } from '../../lib/collectionDatalist'
import { rankLayeringCandidates, layerOptionState, toggleLayerOptionSelection } from '../../lib/layeringPicker'

export default function CollectionLayerRows({ anchor, collection, selected, onChange }) {
  const { user } = useAuth()
  const [queries, setQueries] = useState([''])
  const [error, setError] = useState('')
  const eligible = rankLayeringCandidates({ collection: collectionDatalistItems(collection, user?.id), anchorId: anchor?.id }).map(({ item }) => item)
  const choose = (item, index) => {
    const state = layerOptionState({ option: item, anchor, selected })
    if (state.disabled) { setError(state.reason); return }
    if (!state.selected) onChange(toggleLayerOptionSelection({ option: item, anchor, selected }))
    setQueries(current => current.map((query, i) => i === index ? '' : query))
    setError('')
  }
  return <section data-collection-layer-rows>
    <p className="text-xs text-cream/55">Layered With (optional)</p>
    <div className="mt-2 flex flex-wrap gap-2" role="group" aria-label="Selected layers">
      {selected.map(item => <button key={item.id} type="button" aria-label={`Remove ${collectionDatalistLabel(item)}`} onClick={() => {
        onChange(selected.filter(row => row.id !== item.id)); setError('')
      }} className="pill min-h-11 border border-gold/25 px-3 py-1 text-xs text-gold/80">{collectionDatalistLabel(item)} ×</button>)}
    </div>
    {queries.map((query, index) => <div key={index} className="mt-2">
      <CollectionSearchInput collection={eligible} value={query} aria-label={`Layer ${index + 1}`} placeholder="Add a layer…"
        useNativeDatalist={false}
        onChange={event => setQueries(current => current.map((value, i) => i === index ? event.target.value : value))}
        onSelect={item => choose(item, index)}
        className="min-h-11 w-full rounded-lg border border-white/10 bg-charcoal-700 px-3 py-2 text-base text-cream outline-none focus:border-gold/40" />
      {query && <div className="max-h-48 overflow-y-auto rounded-lg border border-white/10">
        {eligible.filter(item => collectionDatalistLabel(item).toLowerCase().includes(query.toLowerCase())).map(item => <button
          key={item.id} type="button" disabled={layerOptionState({ option: item, anchor, selected }).disabled}
          onClick={() => choose(item, index)} className="block min-h-11 w-full px-3 py-2 text-left text-sm text-cream disabled:opacity-40">{collectionDatalistLabel(item)}</button>)}
      </div>}
    </div>)}
    <button type="button" onClick={() => setQueries(current => [...current, ''])} className="mt-2 min-h-11 w-full rounded-lg border border-dashed border-gold/40 text-sm text-gold">+ Add Layer</button>
    {error && <p role="alert" className="mt-2 text-xs text-amber-200">{error}</p>}
  </section>
}
